// extracted by mini-css-extract-plugin
export default {"hrColor":"ChangesSponsorCompanyTemplate_hrColor__+1Bbr"};